<template >
  <div class="spacialVersionDialog">
    <el-dialog :title="title" :visible.sync="versionDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="versionForm" :model="versionForm"  label-width="140px" :rules="rules">
        <!-- <el-form-item label="所属学段"  class = "is-required"  prop = "stageId" v-if="!this.$props.id">
            <el-select v-model="versionForm.stageId"  placeholder="请选择" @change="changeit">
              <el-option :label="item.name" :value="item.id"   v-for="(item,index ) in stages"  :key="index" ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="所属科目"  class="is-required"  prop="subjectId" v-if="!this.$props.id">
          <el-select v-model="versionForm.subjectId"  placeholder="请选择">
              <el-option :label="item.name" :value="item.id"   v-for="(item,index ) in subjects"  :key="index" ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="版本名称"  class="is-required" prop="name" >
          <el-input v-model.trim="versionForm.name" maxlength="32" placeholder="请输入版本名称"> </el-input>
        </el-form-item>
        <el-form-item label="排序值"  class="is-required" prop="ordinal">
          <el-input v-model.trim="versionForm.ordinal" placeholder="请输入排序值..." maxlength="9"></el-input>
        </el-form-item>
        <el-form-item label="教材类型"  class="is-required"  prop="bookFlag">
          <el-select v-model="versionForm.bookFlag"  placeholder="请选择">
              <el-option label="旧教材" value="0"></el-option>
              <el-option label="新教材" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适用模块"  class="is-required"  prop="specifyModuleId">
          <el-select v-model="versionForm.specifyModuleId"  placeholder="请选择">
              <el-option label="教改园地" :value="1"></el-option>
              <el-option label="同步备课" :value="2"></el-option>
              <el-option label="试卷大全" :value="3"></el-option>
              <el-option label="中考备考" :value="4" v-if="$props.stageId === 3"></el-option>
              <el-option label="高考备考" :value="4" v-if="$props.stageId === 4"></el-option>
              <el-option label="精品专辑" :value="5"></el-option>
              <!-- <el-option label="教师研修" :value="6"></el-option>
              <el-option label="组卷中心" :value="7"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="versionDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import versionService from '@/service/versionService'
import commonService from '@/service/commonService'
export default {
  props: {
    id: {
      type: Number
    },
    subjectId: Number,
    stageId: Number,
    specifyModuleId: Number | String,
    bookFlag: Number | String,
    rowData: Object,
    basicDocumentStatus: Number | String,
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      title: '新增版本',
      loading: false,
      stages: [],
      subjects: [],
      versionForm: {
        id: '',
        name: '',
        // stageId: 0,
        subjectId: 0,
        ordinal: '',
        basicDocumentStatus: 0,
        bookFlag: '',
        specifyModuleId: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入版本名称', trigger: ['blur', 'change']}
        ],
        stageId: [
          {required: true, message: '请选择学段类型', trigger: ['blur', 'change']}
        ],
        subjectId: [
          {required: true, message: '请选择科目类型', trigger: ['blur', 'change']}
        ],
        bookFlag: [
          {required: true, message: '请选择教材类型', trigger: 'change'}
        ],
        specifyModuleId: [
          {required: true, message: '请选择适用模块', trigger: 'change'}
        ],
        ordinal: [
          {required: true, message: '请输入序列号', trigger: 'blur'},
          {pattern: /^[0-9]*$/, message: '请输入数字', trigger: ['blur', 'change']}
        ]
      }
    }
  },
  mounted () {

  },
  async created () {
    // await this.fetchLearnData()
    // await this.fetchClassData()
  },
  methods: {
    changeit () {
      this.fetchClassData()
    },
    async fetchLearnData () {
      try {
        let data = await commonService.fetchCommonStage()
        if (data) {
          // this.versionForm.stageId = data[0].id
          this.stages = data
        } else {
          this.stages = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    async fetchClassData () {
      try {
        let data = await commonService.fetchCommonSubject(parseInt(this.versionForm.stageId))
        if (data && data.length > 0) {
          this.versionForm.subjectId = data[0].id
          this.subjects = data
        } else {
          this.stages = []
          this.subjects = []
        }
      } catch (e) {
        this.$message({
          message: e && e.msg,
          type: 'error'
        })
      }
    },
    save () {
      this.loading = true
      this.$refs.versionForm.validate(async valid => {
        // 验证通过
        if (valid) {
          try {
            await versionService.save(this.versionForm)
            // 重置表单
            // this.$refs.versionForm.resetFields()
            Object.keys(this.versionForm).forEach(key => this.versionForm[key] = '')
            this.$emit('success')
            this.loading = false
            this.versionDialogVisible = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
        this.loading = false
      })
    }
  },
  watch: {
    versionDialogVisible (newVal, oldVal) {
      if (newVal) {
        if (this.$refs.versionForm) {
          // this.$refs.versionForm.resetFields()
          Object.keys(this.versionForm).forEach(key => this.versionForm[key] = '')
          // console.log(this.versionForm)
        }
        // 加载初始化数据
        if (this.$props.id) {
          this.title = '编辑版本'
          this.versionForm = {
            id: this.$props.id,
            name: this.$props.rowData.name,
            bookFlag: this.$props.rowData.bookFlag !== '' ? "" + this.$props.rowData.bookFlag : '',
            description: this.$props.rowData.description,
            year: this.$props.rowData.year,
            subjectId: this.$props.rowData.subjectId,
            specifyModuleId: this.$props.rowData.specifyModuleId,
            ordinal: this.$props.rowData.ordinal,
            basicDocumentStatus: this.$props.basicDocumentStatus
          }
          console.log(this.versionForm)
        } else {
          this.versionForm.name = ''
          // this.versionForm.stageId = this.$props.stageId
          this.versionForm.subjectId = this.$props.subjectId
          this.versionForm.specifyModuleId = this.$props.specifyModuleId
          this.versionForm.basicDocumentStatus = this.$props.basicDocumentStatus
          this.title = '新增版本'
        }
      }
    }
  },
  computed: {
    versionDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>
  .spacialVersionDialog .el-form-item:nth-child(3) .el-input{
    width:80%;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/layout/special-version-manage/edit-dialog/index.vue